import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserRole } from './../../../follow-ups/models/deviation';
import { TranslateService } from '@ngx-translate/core';
import { Module } from 'src/app/kuba/follow-ups/models/deviation';
import { inject, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';

import { HelperService, PdfSetting } from 'src/app/_services/helper.service';
import { Options } from './../../../../_models/options';
import { Timetable } from '../../models/timetable';
import { TimetableServices } from '../../services/timetable.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { EmployeeServices } from './../../../employees/services/employee.services';
import { Subscription, forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Rights, Status } from 'src/app/_models';

@Component({
  selector: 'edit-timetable',
  templateUrl: 'edit-timetable.component.html',
  standalone: false
})
export class EditTimetableComponent implements OnInit {
  //#region variables

  private readonly notifications = inject(NotificationService);
  parentId: number;
  parentKey: any;
  isGuest = false;
  options = [
    new Options(8, 'Open'),
    new Options(6, 'Approved'),
    new Options(10, 'Rejected')
  ];
  timetableId: any;
  EditTimetableForm: FormGroup;
  timetable: any;
  EmployeeTimeTable: Timetable[];
  employeeId: number;
  approvalPersonId: number;
  employeeTimetableId: any;
  isHideStatus = false;
  isVisibleTimetable = false;
  newTimeTable = 'NEW_TIMETABLE';
  isEditTimeTable = false;
  eid: number;
  isParentEmployee: boolean;
  employeeParent: string;
  createdBy: number;
  isReadOnly = false;
  startDate: Date;
  endDate: Date;
  showNotification = false;
  isProject = false;
  additionalData: any;
  isNotUser: boolean;
  workingModule: any;
  userAccess: any;
  allowedEdit: boolean = true;
  allowedStatusChange: boolean = true;
  private subscriptions: Subscription[] = [];

  // #endregion

  //#region constructor
  /**
   * Constructor
   * @param timetableService {TimetableServices}
   * @param _fb {FormBuilder}
   * @param route {ActivatedRoute}
   * @param location {Location}
   */
  constructor(
    private timetableService: TimetableServices,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private confirmationDialog: ConfirmationService,
    private employeeServices: EmployeeServices,
    private translate: TranslateService
  ) {
    this.parentId = this.route.snapshot.params['eid'];
    this.parentKey = this.route.snapshot.data['parent'];
    this.employeeParent = this.route.snapshot.data['parent'];
    this.EditTimetableForm = this._fb.group({
      EmployeeId: ['', Validators.required],
      ProjectName: [''],
      TypeOfWorkId: ['', Validators.required],
      StartDate: ['', Validators.required],
      EndDate: [''],
      StartTime: ['', Validators.required],
      EndTime: ['', Validators.required],
      ActualSpend: [''],
      HoursSpent: [''],
      BreakTime: ['00:00', [], this.breaktime.bind(this)],
      ApprovalUserId: ['', Validators.required],
      TimeTableApproverId: ['', Validators.required],
      Comments: [''],
      Status: [''],
      Id: 0,
      ApprovalDate: null,
      AdditionalDays: [[]]
    });
  }

  /** Subscribe to edit form changes and update HoursSpent dynamically */
  private subscribeToEditFormChanges() {
    if (!this.EditTimetableForm) return;

    const sub = this.EditTimetableForm.valueChanges.subscribe(val => {
      try {
        const sd = HelperService.formatedInputDate(val.StartDate);
        const ed = HelperService.formatedInputDate(val.EndDate);

        const st = this.parseTimeToDate(val.StartTime);
        const et = this.parseTimeToDate(val.EndTime);

        if (sd && ed && st && et) {
          const spenthours = HelperService.calculateHourSpent(sd, ed, st, et);
          let final_spenthours = null;
          // patch HoursSpent without triggering loop

          if (this.EditTimetableForm.get('BreakTime')?.value) {
            // Convert break time to minutes
            const breakMinutes =
              this.EditTimetableForm.get('BreakTime')?.value.getHours() * 60 + this.EditTimetableForm.get('BreakTime')?.value.getMinutes();

            // Convert total hours to minutes
            const [hours, minutes] = spenthours.split(':').map(Number);
            const totalMinutes = hours * 60 + minutes;

            // Subtract break time (ensure it doesn't go negative)
            const remainingMinutes = Math.max(0, totalMinutes - breakMinutes);

            // Convert back to HH:mm format
            const finalHours = Math.floor(remainingMinutes / 60);
            const finalMinutes = remainingMinutes % 60;
            final_spenthours = `${String(finalHours).padStart(2, '0')}:${String(finalMinutes).padStart(2, '0')}`;
          }

          this.EditTimetableForm.patchValue({ HoursSpent: final_spenthours != null ? final_spenthours : spenthours }, { onlySelf: true, emitEvent: false });
        }
      } catch (e) {
        // ignore calculation errors
      }
    });

    this.subscriptions.push(sub);
  }

  private parseTimeToDate(timeVal: any): Date | null {
    if (!timeVal) return null;
    // If already a Date
    if (timeVal instanceof Date) return timeVal;
    // If a string like 'HH:mm' or 'H:mm'
    if (typeof timeVal === 'string') {
      const parts = timeVal.split(':').map(p => parseInt(p, 10));
      if (parts.length >= 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        const d = new Date();
        d.setHours(parts[0], parts[1], 0, 0);
        return d;
      }
      return null;
    }
    // If an object with hours/minutes
    if (timeVal.hours !== undefined && timeVal.minutes !== undefined) {
      const d = new Date();
      d.setHours(timeVal.hours, timeVal.minutes, 0, 0);
      return d;
    }
    return null;
  }

  // #endregion

  //#region page-events

  /**
   * page Init
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.isNotUser = +BaseServices.roleId === UserRole.USER ? false : true;

    if (this.parentKey === 'EMPLOYEE') {
      this.isParentEmployee = true;
    } else {
      this.isParentEmployee = false;
    }
    this.timetableService.getParent(this.isParentEmployee);
    if (BaseServices.roleId === '4') {
      this.isGuest = true;
    }
    if (this.route.snapshot.parent.parent.data['parent'] === 'TIMETABLE') {
      this.parentKey = this.route.snapshot.data['parent'];
    } else {
      this.parentKey = this.route.snapshot.parent.parent.data['parent'];
    }
    if (
      this.parentKey === 'IC' ||
      this.parentKey === 'VEHICLE' ||
      this.parentKey === 'OS' ||
      this.parentKey === 'QS'
    ) {
      this.isHideStatus = true;
    } else {
      this.isHideStatus = false;
    }
    this.eid = this.route.snapshot.params['eid'];
    this.employeeTimetableId = this.route.snapshot.params['tid'];
    if (this.eid) {
      this.isVisibleTimetable = true;
      this.clearTimetableControls();
      this.employeeId = +this.eid
        ? +this.eid
        : this.EditTimetableForm.value.EmployeeId;
      if (this.employeeId) {
        this.EmployeeTimeTable = [];
        let list = <Timetable[]>this.route.snapshot.data['timetable'];
        this.bindTimeTableGrid(list);
      }
      this.timetable = {
        EmployeeId: 0,
        ProjectName: '',
        TypeOfWorkId: '',
        StartDate: null,
        EndDate: null,
        EndTime: null,
        BreakTime: '00:00',
        HoursSpent: null,
        ActualSpend: null,
        Comments: '',
        StartTime: null,
        ApprovalUserId: '',
        ApprovalDate: null,
        TimeTableApproverId: [''],
        Status: 0,
        Id: this.employeeTimetableId ? this.employeeTimetableId : 0,
        AdditionalDays: []
      };
      (<FormGroup>this.EditTimetableForm).setValue(this.timetable, {
        onlySelf: true
      });
    } else {
      this.isEditTimeTable = true;
      this.newTimeTable = 'EDIT_TIMETABLE';
      let timetableInfo = this.route.snapshot.data['edit'];
      timetableInfo.Status =
        timetableInfo.Status && timetableInfo.Status === Status.New
          ? Status.Open
          : timetableInfo.Status;
      timetableInfo.Status = timetableInfo.Status.toString();
      if (timetableInfo.ModuleFeatureId) {
        this.isReadOnly = true;
      }
      this.createdBy = timetableInfo.CreatedBy;
      if (timetableInfo.EndDate === null) {
        timetableInfo.EndDate = timetableInfo.StartDate;
      }
      let approver = [];
      if (timetableInfo.TimeTableApproverId) {
        timetableInfo.TimeTableApproverId.forEach(element => {
          approver.push(element);
        });
      }
      this.isVisibleTimetable = false;
      this.timetableId = timetableInfo.Id;
      if (timetableInfo) {
        timetableInfo.EmployeeId =
          timetableInfo.EmployeeId === null ? '' : timetableInfo.EmployeeId;
        this.approvalPersonId = timetableInfo.ApprovalUserId;
        this.EditTimetableForm = this._fb.group({
          EmployeeId: new FormControl(
            timetableInfo.EmployeeId,
            Validators.required
          ),
          ProjectName: timetableInfo.ModuleFeatureId,
          TypeOfWorkId: new FormControl(
            timetableInfo.TypeOfWorkId,
            Validators.required
          ),
          StartDate: timetableInfo.StartDate
            ? HelperService.formatedInputDate(timetableInfo.StartDate)
            : null,
          EndDate: timetableInfo.EndDate
            ? HelperService.formatedInputDate(timetableInfo.EndDate)
            : null,
          EndTime: timetableInfo.EndTime
            ? HelperService.formatTime(timetableInfo.EndTime)
            : null,
          HoursSpent: timetableInfo.HoursSpent,
          Comments: timetableInfo.Comments,
          StartTime: timetableInfo.StartTime
            ? HelperService.formatTime(timetableInfo.StartTime)
            : null,
          ApprovalUserId: new FormControl(approver, Validators.required),
          TimeTableApproverId: new FormControl(approver),
          Status: new FormControl({
            value:
              timetableInfo.Status === Status.New
                ? Status.Open
                : timetableInfo.Status,
            disabled:
              timetableInfo.ApprovalUserId === BaseServices.UserId
                ? false
                : false
          }),
          Id: timetableInfo.Id,
          BreakTime: timetableInfo.BreakTime
            ? timetableInfo.BreakTime
            : '00:00',
          ActualSpend: null,
          ApprovalDate: timetableInfo.ApprovalDate,
          AdditionalDays: [[]]
        });
      }
      this.workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
      let role = BaseServices.UserRole;
      if (role === 'User') {
        // Cannot figure out what this magic number (8) is? Is it Employees module id?
        if (this.workingModule.id == 8) {
          if (
            timetableInfo.TimeTableApproverId.some
              (e => e === BaseServices.UserId
            )
          ) {
            this.userAccess = false;
          } else {
            this.userAccess = true;
          }
        }
      }
    }

    // Project Name hide/show based on Project Module existence
    let leftNav = JSON.parse(sessionStorage.getItem('leftNav'));
    let filteredTemplate = HelperService.filterTree(
      'Project',
      leftNav.filter(x => {
        if (x.name === 'Project') {
          let childLength = x.children.length;
          if (x.children[3].checked === true) {
            this.isProject = true;
          }
        }
      }),
      'IsProject'
    );
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.TIMETABLE_LIST,
          header: 'Timetable List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Employee Name', dataKey: 'EmployeeName' },
            { title: 'Type of work', datakey: 'ProjectWorkTypeName' }, // added column typeofwork
            { title: 'Comments', dataKey: 'Comments' },
            { title: 'Start Date', dataKey: 'StartDate' },
            { title: 'End Date', dataKey: 'EndDate' },
            { title: 'Start Time', dataKey: 'StartTime' },
            { title: 'End Time', dataKey: 'EndTime' },
            { title: 'Break', dataKey: 'BreakTime' },
            { title: 'Hours Spent', dataKey: 'HoursSpent' },
            { title: 'Approver', dataKey: 'ApprovalUser' },
            { title: 'Approved On', dataKey: 'ApprovalDate' }
          ]
        };
      })
    );

    // Subscribe to form changes to auto-calculate HoursSpent
    this.subscribeToEditFormChanges();
  }

  /**
   * TimeTable DateRange Filter
   * @param StartDate {any}
   * @param EndDate {any}
   */
  TimeTableDateRangeFilter(StartDate: any, EndDate: any) {
    let startDate = StartDate ? StartDate : new Date('1800-01-01');
    let endDate = EndDate ? EndDate : new Date();
    let list = <Timetable[]>this.route.snapshot.data['timetable'];
    if (list) {
      list = list.filter(x => {
        return (
          new Date(x.StartDate) >= startDate && new Date(x.EndDate) <= endDate
        );
      });
      this.bindTimeTableGrid(list);
    }
  }
  // #endregion

  //#region Control-events

  /**
   * Save TimeTable
   */
  saveChanges() {
    this.timetableId = this.employeeTimetableId ? this.employeeTimetableId : 0;
    let timetable =
      this.EditTimetableForm.value.Id > 0
        ? this.EditTimetableForm.value
        : new Timetable();
    timetable = this.EditTimetableForm.value;
    // "Repeat for additional days" (#4833): pull the selection out of the payload
    // so it is not sent to the API, and duplicate the entry onto each extra day.
    const additionalDaysRaw: any[] =
      this.EditTimetableForm.value.AdditionalDays || [];
    delete timetable.AdditionalDays;
    timetable.Status = this.EditTimetableForm.value.Status
      ? this.EditTimetableForm.value.Status
      : Status.Open;
    if (
      timetable.Status == Status.Approved &&
      this.EditTimetableForm.value.ApprovalDate == null
    ) {
      timetable.ApprovalDate = HelperService.formatDate(new Date());
    } else {
      timetable.ApprovalDate = this.EditTimetableForm.value.ApprovalDate;
    }
    timetable.StartDate = this.EditTimetableForm.value
      ? HelperService.formatDateFilter(
          this.EditTimetableForm.value.StartDate
        )
      : null;
    timetable.EndDate = this.EditTimetableForm.value
      ? HelperService.formatDateFilter(
          this.EditTimetableForm.value.EndDate
        )
      : null;
    timetable.StartTime = HelperService.formatTime(
      this.EditTimetableForm.value.StartTime
    );
    timetable.EndTime = HelperService.formatTime(
      this.EditTimetableForm.value.EndTime
    );
    timetable.HoursSpent = this.EditTimetableForm.value.HoursSpent;
    timetable.BreakTime = HelperService.formatTime(
      this.EditTimetableForm.value.BreakTime
    );
    if (timetable.BreakTime !== null && timetable.BreakTime !== '') {
      let splitBreakTime = timetable.BreakTime.split(':')[1];
      if (splitBreakTime.length === 1) {
        timetable.BreakTime =
          timetable.BreakTime.split(':')[0] +
          ':' +
          '0' +
          timetable.BreakTime.split(':')[1];
      }
    }
    let TimeTable = [];
    TimeTable = timetable.ApprovalUserId;
    timetable.TimeTableApproverId = [];
    let approvalPerson = this.route.snapshot.data['approvalPerson'];
    if (TimeTable != null) {
      TimeTable.forEach(element => {
        if (approvalPerson.filter(x => x.Id === element).length > 0) {
          timetable.TimeTableApproverId.push(
            approvalPerson.filter(x => x.Id === element)[0].Id
          );
        }
      });
    }
    timetable.BusinessId = BaseServices.BusinessId;
    timetable.ApprovalUserId = null;
    let val: any;
    if (this.EditTimetableForm.value.ProjectName) {
      val = this.EditTimetableForm.value.ProjectName.split('_');
    }
    if (this.employeeParent === 'EMPLOYEE') {
      let featureId: number;
      if (val) {
        if (val[0] === 'PROJECT') {
          featureId = Module.PROJECT;
        } else if (val[0] === 'FOODSAFETY') {
          featureId = Module.FOODSAFETY;
        } else if (val[0] === 'INTERNALCONTROL') {
          featureId = Module.INTERNALCONTROL;
        } else if (val[0] === 'VEHICLE') {
          featureId = Module.VEHICLE;
        } else if (val[0] === 'FIREDEVIATION') {
          featureId = Module.FIREDEVIATION;
        } else if (val[0] === 'SERVICE') {
          featureId = Module.SERVICEAGREEMENT;
        } else if (val[0] === 'FRAMEWORK') {
          featureId = Module.FRAMEWORKAGREEMENT;
        } else if (val[0] === 'KUNDE') {
          featureId = Module.Kunde_EL;
        }
        if (val[0] === 'SERVICE' || val[0] === 'KUNDE') {
          timetable.Featurekey = val[2] !== null ? +val[2] : 0;
          timetable.FeatureId = featureId;
        } else {
          timetable.Featurekey = val[1] ? +val[1] : this.parentId; // project or zone feature key
          timetable.FeatureId = featureId ? featureId : this.employeeParent; // // project or zone feature Id
        }
      } else {
        timetable.Featurekey = this.parentId;
        timetable.FeatureId = Module.EMPLOYEES;
      }
    } else {
      timetable.Featurekey = this.parentId;
    }
    timetable.ProjectId = val ? +val[1] : 0;
    if (timetable) {
      if (timetable.Id > 0 || this.timetableId > 0) {
        if (this.parentKey === 'TIMETABLE') {
          timetable.Id = this.timetableId;
          timetable.EmployeeId = this.eid;
          this.employeeId = this.eid;
        } else {
          timetable.Id = this.timetableId ? this.timetableId : 0;
          timetable.EmployeeId = this.EditTimetableForm.value.EmployeeId;
          this.employeeId = this.EditTimetableForm.value.EmployeeId;
        }
        timetable.CreatedBy = this.createdBy;
        timetable.ModifiedBy = BaseServices.UserId;
        this.subscriptions.push(
          this.timetableService
            .updateTimetable(timetable.Id, timetable)
            .pipe(finalize(() => this.getTimetableByEmpId(this.employeeId)))
            .subscribe(isSaved => {
              if (isSaved) {
                this.clearTimetableControls();
                this.timetableId = 0;
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
              }
            })
        );
      } else {
        timetable.CreatedBy = BaseServices.UserId;
        timetable.Status = this.EditTimetableForm.value.Status;
        timetable.EmployeeId = this.employeeId;
        timetable.Id = this.timetableId;
        const extraDates = this.getUniqueAdditionalDates(
          additionalDaysRaw,
          timetable.StartDate
        );
        if (extraDates.length === 0) {
          this.subscriptions.push(
            this.timetableService
              .addTimetable(timetable, this.parentKey)
              .subscribe(IsTimeTableSaved => {
                if (IsTimeTableSaved) {
                  this.clearTimetableControls();
                  this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  this.getTimetableByEmpId(this.employeeId);
                  this.ngOnInit();
                }
              })
          );
        } else {
          // base day + one single-day record per additional day
          const payloads: any[] = [timetable];
          extraDates.forEach(dateStr => {
            const clone = { ...timetable };
            clone.StartDate = dateStr;
            clone.EndDate = dateStr;
            payloads.push(clone);
          });
          this.subscriptions.push(
            forkJoin(
              payloads.map(p =>
                this.timetableService.addTimetable(p, this.parentKey)
              )
            ).subscribe(results => {
              if (results.some(r => r)) {
                this.clearTimetableControls();
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.getTimetableByEmpId(this.employeeId);
                this.ngOnInit();
              }
            })
          );
        }
      }
    }
  }
  resetTimeTable() {
    this.employeeTimetableId = 0;
    this.EditTimetableForm.reset();
  }
  getTimetableByEmpId(empId: number) {
    this.subscriptions.push(
      this.employeeServices
        .getTimeTableByEmployeeId(this.employeeId)
        .subscribe(list => {
          this.bindTimeTableGrid(list);
        })
    );
  }
  /**
   * To go TimeTable List
   */
  gotoBack() {
    this.location.back();
  }

  /**
   * Print list
   */
  print() {
    this.confirmationDialog.confirm({
      message: 'Are you sure that you want to generate report?',
      accept: () => {
        let pdfSetting = new PdfSetting();
        pdfSetting.date = 'Date:' + HelperService.formatDate(new Date());
        pdfSetting.businessName = BaseServices.BusinessName;
        pdfSetting.pageHeader = 'Timetable';
        let data = this.EmployeeTimeTable;
        if (data.length > 0) {
          let columns = [
            { title: 'Type of work', datakey: 'ProjectWorkTypeName' },
            { title: 'Project Name', dataKey: 'ProjectName' },
            { title: 'Name', dataKey: 'EmployeeName' },
            { title: 'Comments', dataKey: 'Comments' },
            { title: 'Start Date', dataKey: 'StartDate' },
            { title: 'End Date', dataKey: 'EndDate' },
            { title: 'End Time', dataKey: 'EndTime' },
            { title: 'Break', dataKey: 'BreakTime' },
            { title: 'Total Hours Spent', dataKey: 'HoursSpent' },
            { title: 'Approver', dataKey: 'ApprovalUser' },
            { title: 'Approved On', dataKey: 'ApprovalDate' }
          ];
          HelperService.generatePdf(
            data,
            columns,
            'Timetable',
            pdfSetting,
            'l'
          );
        } else {
          this.showNotification = true;
        }
      }
    });
  }

  /**
   * Gets a time table from the grid, and then fills the time table form.
   * It also checks if the user is allowed to edit the time table
   * (Is checked for approved time tables)
   * @param employeeTimeTableId time table from grid
   */
  editEmployeeTimeTable(TimeTable: any) {
    this.isEditTimeTable = true;
    this.newTimeTable = 'EDIT_TIMETABLE';
    this.subscriptions.push(
      this.timetableService
        .getTimeTableByTimeTableId(
          TimeTable.Id,
          TimeTable.FeatureId,
          TimeTable.FeatureKey
        )
        .subscribe((employeeTimeTable: any) => {
          this.isReadOnly = employeeTimeTable.ModuleFeatureId !== null;
          this.timetableService.getReadOnly(this.isReadOnly);
          this.employeeTimetableId = employeeTimeTable.Id;
          if (employeeTimeTable) {
            employeeTimeTable.BreakTime =
              employeeTimeTable.BreakTime === '00:00:00'
                ? null
                : employeeTimeTable.BreakTime;
            let timetable;
            let ApprovalUserId;
            if (employeeTimeTable['ApprovalUserId']) {
              ApprovalUserId = employeeTimeTable['ApprovalUserId'];
            } else {
              ApprovalUserId = TimeTable['ApprovalUserIdList'];
            }
            timetable = {
              Id: employeeTimeTable.Id,
              EmployeeId: employeeTimeTable.EmployeeId,
              ProjectName: employeeTimeTable.ModuleFeatureId,
              TypeOfWorkId: employeeTimeTable.TypeOfWorkId,
              StartDate: employeeTimeTable.StartDate
                ? HelperService.formatedInputDate(employeeTimeTable.StartDate)
                : null,
              EndDate: employeeTimeTable.EndDate
                ? HelperService.formatedInputDate(employeeTimeTable.EndDate)
                : null,
              EndTime: employeeTimeTable.EndTime
                ? HelperService.formatTime(employeeTimeTable.EndTime)
                : null,
              ApprovalDate: employeeTimeTable.ApprovalDate,
              HoursSpent: employeeTimeTable.HoursSpent,
              ActualSpend:
                employeeTimeTable.BreakTime !== null &&
                employeeTimeTable.BreakTime !== ''
                  ? this.calculateHourSpent(
                      employeeTimeTable.BreakTime,
                      employeeTimeTable.HoursSpent
                    )
                  : employeeTimeTable.HoursSpent,
              BreakTime: employeeTimeTable.BreakTime
                ? HelperService.formatTime(employeeTimeTable.BreakTime)
                : null,
              Comments: employeeTimeTable.Comments,
              StartTime: employeeTimeTable.StartTime
                ? HelperService.formatTime(employeeTimeTable.StartTime)
                : null,
              TimeTableApproverId: employeeTimeTable.TimeTableApproverId,
              ApprovalUserId: employeeTimeTable.TimeTableApproverId,
              Status:
                employeeTimeTable.Status === Status.New
                  ? Status.Open
                  : employeeTimeTable.Status,
              AdditionalDays: []
            };
            this.validateEditRights(employeeTimeTable);
            (<FormGroup>this.EditTimetableForm).setValue(timetable, {
              onlySelf: true
            });
          }
        })
    );
  }

  deleteEmployeeTimeTable(employeeTimetableId: any) {
    this.confirmationDialog.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.timetableService
            .DeleteTimetable(employeeTimetableId)
            .subscribe(isTimetableDeleted => {
              if (isTimetableDeleted) {
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                this.refreshList();
              }
            })
        );
      }
    });
  }

  refreshList() {
    this.subscriptions.push(
      this.employeeServices
        .getTimeTableByEmployeeId(this.employeeId)
        .subscribe(timetableInfo => {
          if (timetableInfo) {
            this.EmployeeTimeTable = timetableInfo;
          }
        })
    );
  }

  /**
   * Clearing the time table form and reenables write mode for fields if
   * neccesary.
   */
  clearTimetableControls() {
    this.isEditTimeTable = false;
    this.allowedEdit = true;
    this.allowedStatusChange = true;
    this.newTimeTable = 'NEW_TIMETABLE';
    this.employeeTimetableId = 0;
    this.EditTimetableForm.reset();
  }

  // #endregion

  //#region methods

  /**
   * checking the retrieved data
   * @param data {any}
   */
  checkNullorEmpty(data: any) {
    return data ? data : '';
  }

  /**
   * sets month and year in the timetable model
   * @param timeTableList {any}
   */
  bindTimeTableGrid(timeTableList: any) {
    if (timeTableList) {
      this.EmployeeTimeTable = [];
      timeTableList.forEach((timeTable: any) => {
        if (timeTable && timeTable.StartDate) {
          timeTable.Month = `${new Date(timeTable.StartDate).getMonth() + 1}`;
          timeTable.Year = `${new Date(timeTable.StartDate).getFullYear()}`;
        }
        this.EmployeeTimeTable.push(timeTable);
      });
    }
  }
  /**
   * start date change event
   * @param event {IMyDateModel}
   */
  onTimeTableStartDateChanged(event) {
    const d = this.normalizeDateEvent(event);
    this.startDate = d;
    if (d) {
      this.TimeTableDateRangeFilter(this.startDate, this.endDate);
    } else {
      const list = <Timetable[]>this.route.snapshot.data['timetable'];
      this.bindTimeTableGrid(list);
    }
  }

  /**
   * End date change event
   * @param event {IMyDateModel}
   */
  onTimeTableEndDateChanged(event) {
    const d = this.normalizeDateEvent(event);
    this.endDate = d;
    if (d) {
      this.TimeTableDateRangeFilter(this.startDate, this.endDate);
    } else {
      const list = <Timetable[]>this.route.snapshot.data['timetable'];
      this.bindTimeTableGrid(list);
    }
  }

  /** Clear both caption filter calendars and reset the table */
  clearTimeTableFilters(fromCal: any, endCal: any) {
    try {
      if (fromCal && typeof fromCal.clear === 'function') fromCal.clear();
      if (endCal && typeof endCal.clear === 'function') endCal.clear();
    } catch (e) {
      // ignore
    }
    this.startDate = null;
    this.endDate = null;
    const list = <Timetable[]>this.route.snapshot.data['timetable'];
    this.bindTimeTableGrid(list);
  }

  /**
   * Accepts either a PrimeNG p-calendar Date (Date), or null and returns a Date or null.
   */
  private normalizeDateEvent(event: any): Date | null {
    if (!event) return null;
    if (event instanceof Date) return event;
    if (event.jsdate) return new Date(event.jsdate.getTime());
    // PrimeNG might pass an object with a 'value' field containing Date
    if (event.value instanceof Date) return event.value;
    return null;
  }
  // #endregion

  /**
   * go to list
   */
  gotoList() {
    this.location.back();
  }
  /**
   * convert hours to minutes
   */
  timeConvert(n) {
    let num = n;
    let hours = num / 60;
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    return rhours + ':' + rminutes;
  }
  /** */
  breaktime(breakTime: FormControl) {
    let isShowValidation = false;
    let btimemints = null;
    let htimemints;
    let bhour: any = null;
    let bmin: any = null;
    if (this.EditTimetableForm) {
      if (
        breakTime.value != null &&
        breakTime.value !== '00:00' &&
        breakTime.value !== ''
      ) {
        bhour = new Date(breakTime.value).getHours();
        bmin = new Date(breakTime.value).getMinutes();
        btimemints = parseInt(bhour, 0) * 60 + parseInt(bmin, 0);
        btimemints = isNaN(btimemints) ? null : btimemints;
      }
      let hourSpent: any =
        this.EditTimetableForm.value.ActualSpend === ''
          ? null
          : this.EditTimetableForm.value.ActualSpend;
      if (hourSpent !== null) {
        htimemints =
          parseInt(hourSpent.split(':')[0], NaN) * 60 +
          parseInt(hourSpent.split(':')[1], NaN);
        if (
          btimemints !== null &&
          breakTime.value !== '00:00' &&
          breakTime.value !== ''
        ) {
          if (btimemints < htimemints) {
            let newHoursSpent: any =
              parseInt(htimemints, 0) - parseInt(btimemints, NaN);
            this.EditTimetableForm.get('HoursSpent').patchValue(
              this.timeConvert(newHoursSpent)
            );
          } else {
            isShowValidation = true;
          }
        }
      }
    }
    const q = new Promise(resolve => {
      if (isShowValidation === true) {
        resolve({ break_time: true });
      } else {
        resolve(null);
      }
    });
    return q;
  }

  /**
   *
   */
  calculateHourSpent(bteakTime: string, hourSpent: string) {
    let btimemints;
    let htimemints;
    let newHoursSpent: any;
    btimemints =
      parseInt(bteakTime.split(':')[0], 0) * 60 +
      parseInt(bteakTime.split(':')[1], 0);
    htimemints =
      parseInt(hourSpent.split(':')[0], 0) * 60 +
      parseInt(hourSpent.split(':')[1], 0);
    newHoursSpent = parseInt(htimemints, 0) + parseInt(btimemints, NaN);
    return this.timeConvert(newHoursSpent);
  }

  /**
   * Checks if an user is allowed to edit a time table / has the rights to edit
   * a time table, and what the parts the of the form the user is allowed to edit.
   * @param timeTable Time table to check
   */
  validateEditRights(timeTable: Timetable) {
    // Editing non-approved time tables are allways allowed.
    const approveTimeTableRights = BaseServices.checkUserRights(
      Rights.APPROVE_TIMETABLE,
      BaseServices.UserRole
    );
    if (approveTimeTableRights) {
      this.allowedEdit = true;
      this.allowedStatusChange = true;
    } else if (
      !approveTimeTableRights &&
      timeTable.Status !== Status.Approved
    ) {
      this.allowedEdit = true;
      this.allowedStatusChange = false;
    } else {
      this.allowedEdit = false;
      this.allowedStatusChange = false;
    }
  }

  /**
   * Normalizes the "additional days" selection into unique formatted dates,
   * dropping any that equal the base start date (already saved as the base record).
   * @param selected {any[]} raw dates from the multi-select calendar
   * @param baseStartDate {any} formatted start date of the base record
   * @returns {string[]}
   */
  private getUniqueAdditionalDates(
    selected: any[],
    baseStartDate: any
  ): string[] {
    const seen = new Set<string>();
    const result: string[] = [];
    (selected || []).forEach(day => {
      if (!day) {
        return;
      }
      const formatted = HelperService.formatDateFilter(day);
      if (!formatted || formatted === baseStartDate || seen.has(formatted)) {
        return;
      }
      seen.add(formatted);
      result.push(formatted);
    });
    return result;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
